import { render, staticRenderFns } from "./ProfileDownlineView.vue?vue&type=template&id=885f6a9c&scoped=true"
import script from "./ProfileDownlineView.vue?vue&type=script&lang=js"
export * from "./ProfileDownlineView.vue?vue&type=script&lang=js"
import style0 from "./ProfileDownlineView.vue?vue&type=style&index=0&id=885f6a9c&prod&scoped=true&lang=css"
import style1 from "./ProfileDownlineView.vue?vue&type=style&index=1&id=885f6a9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "885f6a9c",
  null
  
)

export default component.exports